import 'dragula/dist/dragula.css';

import dragula from 'dragula';

/**
 * Whenever we want to use dragula, we should import it
 * through this file. That means that the CSS that is inside
 * of the dragula dependency will also be imported onto the
 * page.
 *
 * If you import dragula directly, like:
 *
 * import dragula from 'dragula';
 *
 * The css doesn't come along, and dragula may not work properly.
 */

export default dragula;
